import { gql } from '@apollo/client';

export const REMOVE_LINKED_INCIDENT = gql`
  mutation removeLinkedIncident($input: RemoveLinkedIncidentInput!) {
    removeLinkedIncident(input: $input) {
      errors
    }
  }
`

//Example input:
// {
//   "input": {
//     "incidentId": ID,
//     "originatorId": ID
//   }
// }

